import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../_metronic/helpers'

const API_URL = process.env.REACT_APP_THEME_API_URL
const GET_PROJECT_TEMPLATE_URL = `${API_URL}/api/project-template`

export const getProjectTemplateById = (id: number): Promise<any> => {
  return axios
    .get(`${GET_PROJECT_TEMPLATE_URL}/${id}`)
    .then((response: AxiosResponse<any>) => response.data)
}

export const getProjectTemplateTaskTemplates = (
  projectTemplateId: number,
  page: number,
  perPage?: number
): Promise<any> => {
  const safePage = Math.max(1, Math.floor(page) || 1)
  const params: Record<string, number> = {page: safePage}
  if (perPage != null && perPage > 0) {
    params.per_page = Math.min(200, Math.floor(perPage))
  }
  return axios
    .get(`${GET_PROJECT_TEMPLATE_URL}/${projectTemplateId}/task-templates`, {params})
    .then((d: AxiosResponse<any>) => d.data)
}

export const getProjectTemplatesList = (page: number, perPage?: number, search?: string): Promise<any> => {
  const safePage = Math.max(1, Math.floor(page) || 1)
  const params: Record<string, number | string> = {page: safePage}
  if (perPage != null && perPage > 0) {
    params.per_page = Math.min(200, Math.floor(perPage))
  }
  if (search != null && search.trim() !== '') {
    params.search = search.trim()
  }
  return axios.get(GET_PROJECT_TEMPLATE_URL, {params}).then((d: AxiosResponse<any>) => d.data)
}

export const createProjectTemplate = (projectTemplate: {name: string}): Promise<any> => {
  return axios
    .post(`${GET_PROJECT_TEMPLATE_URL}/novo`, projectTemplate)
    .then((response: AxiosResponse<any>) => response.data)
}

export const updateProjectTemplate = (template: {id: number; name: string}): Promise<any> => {
  return axios
    .put(`${GET_PROJECT_TEMPLATE_URL}/${template.id}/editar`, template)
    .then((response) => response.data)
}

export const deleteProjectTemplate = (templateId: number): Promise<any> => {
  return axios
    .delete(`${GET_PROJECT_TEMPLATE_URL}/${templateId}/excluir`)
    .then((response) => response.data)
}

export const deleteTaskTemplate = (
  projectTemplateId: number,
  taskTemplateId: number
): Promise<any> => {
  return axios
    .delete(
      `${GET_PROJECT_TEMPLATE_URL}/${projectTemplateId}/task-templates/${taskTemplateId}/delete`
    )
    .then((response) => response.data)
}

export const addTaskTemplate = (
  projectTemplateId: number,
  taskTemplate: any
): Promise<any> => {
  return axios
    .post(
      `${GET_PROJECT_TEMPLATE_URL}/${projectTemplateId}/task-templates/${taskTemplate.id}/add`
    )
    .then((response) => response.data)
}
